<div class="mc-live-log">
  <div *ngIf="generalError || (loading && lines.length === 0)" class="mc-loader mc-live-log-overlay">
    <mc-errors-expansion-panel *ngIf="generalError" [generalError]="generalError" [detailedErrors]="detailedErrors"></mc-errors-expansion-panel>
    <ng-container *ngIf="!generalError">
      <p class="mc-form-text">Loading log...</p>
      <mat-progress-bar class="mc-progress-bar-large" color="accent-vivid" mode="indeterminate"></mat-progress-bar>
    </ng-container>
  </div>
  <!-- Virtual scroll viewport is always in the DOM so @ViewChild(static:true) is stable.
       The loading overlay sits on top via position:absolute when loading. tabindex makes it
       focusable so keydown.control.f (host-scoped, see the component) can actually reach it. -->
  <cdk-virtual-scroll-viewport class="mc-live-log-output" tabindex="0" [itemSize]="LINE_HEIGHT_PX">
    <div *cdkVirtualFor="let line of linesSubject; let i = index; trackBy: trackLine" class="mc-live-log-line mc-live-log-line-{{ line.severity }} mc-live-log-line-{{ line.kind }}">
      <ng-container *ngIf="timestampMode === 'utc' && line.timestampUtc">
        <span class="mc-live-log-timestamp">{{ line.timestampUtc }}</span>
        <span class="mc-live-log-sep">{{ ' ' }}</span>
      </ng-container>
      <ng-container *ngIf="timestampMode === 'local' && line.timestampLocal">
        <span class="mc-live-log-timestamp">{{ line.timestampLocal }}</span>
        <span class="mc-live-log-sep">{{ ' ' }}</span>
      </ng-container>
      <ng-container *ngIf="showIcons">
        <span class="mc-live-log-icon" aria-hidden="true">{{ iconFor(line) }}</span>
        <span class="mc-live-log-sep">{{ ' ' }}</span>
      </ng-container>
      <ng-container *ngIf="messageParts.get(i) as segs; else plainMsg">
        <ng-container *ngFor="let seg of segs">
          <mark *ngIf="seg.isMatch" class="mc-live-log-match" [class.mc-live-log-match-current]="currentMatchLineIndex === i && currentMatchOccurrenceIndex === seg.occurrenceIndex">{{ seg.text }}</mark>
          <ng-container *ngIf="!seg.isMatch">{{ seg.text }}</ng-container>
        </ng-container>
      </ng-container>
      <ng-template #plainMsg>{{ line.message }}</ng-template>
      <span *ngIf="line.sourceLabel" class="mc-live-log-source"> [<a *ngIf="getSourceRouterLink(line.src) as sourceLink; else sourcePlain" class="mc-live-log-source-link" [routerLink]="sourceLink" [queryParams]="line.srcLine ? { line: line.srcLine } : null">{{ line.sourceLabel }}</a><ng-template #sourcePlain>{{ line.sourceLabel }}</ng-template>]</span>
    </div>
    <span *ngIf="!generalError && !loading && !isComplete && lines.length === 0" class="mc-live-log-empty">{{ emptyLabelOverride || 'Waiting for output...' }}</span>
    <span *ngIf="!generalError && isComplete && lines.length === 0" class="mc-live-log-empty">{{ emptyLabelOverride || 'No entries.' }}</span>
  </cdk-virtual-scroll-viewport>

  <!-- Find overlay — shown on Ctrl+F, closed by Esc or the × button -->
  <div *ngIf="findOpen" class="mc-live-log-search mat-elevation-z3">
    <input #findInput id="mc-live-log-find-input" type="text" class="mc-live-log-search-input" [value]="findTerm" (input)="onFindInput($any($event.target).value)" (keydown.enter)="nextMatch()" (keydown.shift.enter)="prevMatch()" placeholder="Find" autocomplete="off" spellcheck="false">
    <span class="mc-live-log-search-count">
      {{ matchCount > 0 ? (currentMatchPosition + ' of ' + matchCount) : (findTerm ? 'No results' : '') }}
    </span>
    <button mat-icon-button class="mc-live-log-search-nav" [disabled]="!matchCount" (click)="prevMatch()" matTooltip="Previous (Shift+Enter)">
      <mat-icon fontSet="project-titan" fontIcon="icon-up-arrow-90"></mat-icon>
    </button>
    <button mat-icon-button class="mc-live-log-search-nav" [disabled]="!matchCount" (click)="nextMatch()" matTooltip="Next (Enter)">
      <mat-icon fontSet="project-titan" fontIcon="icon-down-arrow-90"></mat-icon>
    </button>
    <button mat-icon-button class="mc-live-log-search-close" (click)="closeFind()" matTooltip="Close (Esc)">
      <mat-icon fontSet="project-titan" fontIcon="icon-close"></mat-icon>
    </button>
  </div>
</div>
